module.exports = __webpack_public_path__ + "img/3.8bdfe31e.png";